import { styled } from 'styled-components';

import {
  layoutHeaderPanelIconSlotWidth,
  LayoutHeaderPanelLink,
  layoutHeaderPanelRowCss,
  LayoutHeaderPanelRowsHolder,
  LayoutHeaderPanelSectionTitle,
} from '#/layouts/Layout/Header/Panel/LayoutHeaderPanel.styled';
import { colors, cssBreakpoints, gutterWidth, spacing } from '#/theme/theme';

const organizationCardInset = 12;

export const HamburgerMenuHolder = styled.div`
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const HamburgerMenuSectionHolder = styled.section`
  & + & {
    border-top: 1px solid ${colors.selectionGrey};
  }
`;

export const HamburgerMenuRowsHolder = styled(LayoutHeaderPanelRowsHolder)`
  &[data-nested] {
    padding-left: ${layoutHeaderPanelIconSlotWidth + 12}px;
  }
`;

export const HamburgerMenuExpandableButton = styled.button`
  ${layoutHeaderPanelRowCss};
  border: 0;
  background: none;
  cursor: pointer;
  font-family: inherit;

  &[aria-expanded='true'] {
    color: ${colors.brandBlue};
  }
`;

export const HamburgerMenuRowChevronHolder = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  margin-left: auto;
`;

// Not a HamburgerMenuSectionHolder, so the section below gets no top border
export const HamburgerMenuOrganizationCard = styled.section`
  margin: ${spacing[16]} ${organizationCardInset}px 0;
  padding-bottom: ${spacing[4]};
  border-radius: 8px;
  background: ${colors.softBlue};
  overflow: hidden;

  ${LayoutHeaderPanelSectionTitle},
  ${LayoutHeaderPanelLink},
  ${HamburgerMenuExpandableButton} {
    /* Only the tint is inset: icons and text line up with the rest of the menu */
    padding-left: ${gutterWidth / 2 - organizationCardInset}px;
    padding-right: ${gutterWidth / 2 - organizationCardInset}px;
  }
`;

export const HamburgerMenuOrgLink = styled(LayoutHeaderPanelLink)`
  padding-top: ${spacing[12]};
  padding-bottom: ${spacing[12]};
  overflow-wrap: anywhere;

  &[aria-current] {
    color: ${colors.brandBlue};
  }
`;
